import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface ClickableIconProps {
  children: React.ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const ClickableIcon: React.FC<ClickableIconProps> = ({
  children,
  onClick,
  sx = {},
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.8,
        },
        transition: 'opacity 0.2s ease',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ClickableIcon;